<div class="popup-container">
  <div class="popup-header">
    <h2>Configure Zoom Meetings</h2>
    <p class="subtitle">Set up your integration settings and authentication</p>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="instructions-box">
    <p class="instructions-title">
      <mat-icon style="color: #310737;">info</mat-icon> Zoom App Setup
    </p>
    <p class="instructions-text">
      Create a Zoom App in the Zoom Marketplace and obtain your API credentials.
    </p>
    <a href="https://marketplace.zoom.us/" target="_blank" class="doc-link">
      <mat-icon inline>launch</mat-icon> Zoom Marketplace
    </a>
  </div>

  <form class="form-section" (ngSubmit)="save()">
    <div class="form-field">
      <label>API Key *</label>
      <input type="text" placeholder="Zoom API Key" [(ngModel)]="formData.apiKey" name="apiKey" required />
    </div>

    <div class="form-field">
      <label>API Secret *</label>
      <input type="text" placeholder="Zoom API Secret" [(ngModel)]="formData.apiSecret" name="apiSecret" required />
    </div>

    <div class="form-field">
      <label>Account ID</label>
      <input type="text" placeholder="Zoom Account ID" [(ngModel)]="formData.accountId" name="accountId" />
    </div>

    <div class="dialog-footer">
<button mat-stroked-button class="cancel-btn" type="button" (click)="close()">Cancel</button>
<button mat-flat-button color="primary" class="save-btn" type="submit">
  Save Configuration
</button>

    </div>
  </form>
</div>
